module.exports = __webpack_public_path__ + "8a91cc9b0083fdad025c136cce4ad69c.png";